import gql from "graphql-tag";

import ProductFragment from "../../../fragments/product.fragment";

/*
 * Find a product by it's primary key (as known by magento).
 *
 * Do NOT change the "operation name", as it's used for caching purposes.
 */
const GetProduct = gql`
  query GetProductById($id: ID!) {
    product(id: $id) {
      ...ProductFragment
    }
  }

  ${ProductFragment}
`;

export default GetProduct;
